const APP_CONTEXT_CACHE_TTL_MS = 60_000

const isAppContextPrivacyCenterCacheStale = (cachedAt?: number) => {
  if (cachedAt === undefined) return true

  return Date.now() - cachedAt > APP_CONTEXT_CACHE_TTL_MS
}

export { APP_CONTEXT_CACHE_TTL_MS, isAppContextPrivacyCenterCacheStale }
